import { __rest } from "tslib";
import * as React from 'react';
import { Divider } from '../Divider';
export const OptionsMenuSeparator = (_a) => {
    var { component = 'li' } = _a, props = __rest(_a, ["component"]);
    return React.createElement(Divider, Object.assign({ component: component }, props));
};
OptionsMenuSeparator.displayName = 'OptionsMenuSeparator';
//# sourceMappingURL=OptionsMenuSeparator.js.map